import { connect } from 'react-redux'
import BlockForm from '../presentational/block_form'
import { createBlock, displayMode, DISPLAY_MODES } from '../../actions'

const mapStateToProps = state => ({
  tabs: state.tabs,
  activeTab: state.filters.active_tab,
  usesTranslations: state.filters.uses_translations,
  availableLanguages: state.filters.available_languages,
  currentLanguage: state.filters.current_language,
})

const mapDispatchToProps = dispatch => ({
  createBlock: (tabId, title, titles, layout) => {
    dispatch(createBlock(tabId, title, titles, layout))
    dispatch(displayMode(DISPLAY_MODES.DEFAULT))
  },
  cancel: () => {
    dispatch(displayMode(DISPLAY_MODES.DEFAULT))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BlockForm)
